export const getReportQuarterlyMaintenanceService =
  (fetch) =>
  async ({ filters }) => {
    try {
      const searchParams = new URLSearchParams(filters).toString();
      const response = await fetch({
        url:
          "/api/v1/mantenimiento/reporte-mantenimiento-trimestral?" +
          searchParams,
      });

      return response;
    } catch (error) {
      throw new Error(error.response?.data?.detail || error.message);
    }
  };
